import Component from '../core/Component'
import support from '../utils/BrowserSupport'
import EventBus from '../core/EventBus'
import scrollToElement from '../services/Viewport/scrollToElement'

export const STATES = {
    ACTIVE: 'is-active',
    ANIMATION_DISABLED: 'is-animation-disabled'
}

export default class Accordion extends Component{

    constructor(element) {
        super(element)

        this.ref = {
            toggles: [],
            contents: [],
            items: []
        }

        this.current = -1
        this.delay = {
            scroll: false,
            offset: 0,
            force: false
        }

        this.promise = {
            resolve: null,
            reject: null
        }
    }

    prepare() {
        this.ref.toggles.forEach(element => element.addEventListener('click', this.handleClick))
        this.ref.contents.forEach(element => element.addEventListener(support.transitionEnd, this.handleTransitionEnd))
        this.ref.contents.forEach(element => element.style.height = '0px')

        this.ref.items.forEach(element => {
            if (element.id) {
                element.dataset.originalId = element.id
                element.id = 'accordion-' + element.id
            }
        })

        EventBus.on('anchor:click', this.handleAnchorClick)

        const fragment = window.location.hash.replace('#', '')

        if (fragment) {
            const index = this.ref.items.findIndex(element => element.id ===  'accordion-' + fragment)

            if (index > -1) {
                this.scrollToView(index)
            }
        }

    }

    handleClick = event => {
        const index = this.ref.toggles.indexOf(event.currentTarget)

        if (index === -1) {
            return
        }

        this.toggle(index)
    }

    handleAnchorClick = ({ anchor, event }) => {
        const id = anchor.replace('#', '')

        const element = document.getElementById(`accordion-${id}`)

        if (!element) {
            return
        }

        const index = this.ref.items.indexOf(element)

        if (index > -1) {
            event.preventDefault()
            this.scrollToView(index)
            this.open(index)
        }
    }

    toggle(index) {
        if (this.ref.items[index].dataset.disabled) {
            return
        }
        if (index === this.current) {
            this.close(index)
        } else {
            this.scrollToView(index)
            this.open(index)
        }
    }

    createPromise() {
        let res, rej

        const promise = new Promise((resolve, reject) => {
            res = resolve
            rej = reject
        })

        promise.resolve = res
        promise.reject = rej

        return promise
    }

    open(index, force = false) {
        if (this.ref.items[index].dataset.disabled) {
            return
        }
        if (this.current > -1) {
            this.close(this.current, force)
        }

        this.ref.items[index].classList.add(STATES.ACTIVE)

        if (force) {
            this.element.classList.add(STATES.ANIMATION_DISABLED)
            this.element.offsetWidth
        }

        const content = this.ref.contents[index]
        content.style.height = `${content.scrollHeight}px`

        this.current = index

        if (force) {
            this.clear(content)
            this.element.classList.remove(STATES.ANIMATION_DISABLED)
            this.element.offsetWidth
        }

        let promise = this.createPromise()

        if (force) {
            promise.resolve()
            this.promise = null
        } else {
            this.promise = promise
        }

        return promise

    }

    close(index, force = false) {
        if (this.ref.items[index].dataset.disabled) {
            return
        }

        if (force) {
            this.element.classList.add(STATES.ANIMATION_DISABLED)
            this.element.offsetWidth
        }

        this.ref.items[index].classList.remove(STATES.ACTIVE)
        const content = this.ref.contents[index]
        content.style.height = `${content.scrollHeight}px`
        content.offsetHeight
        content.style.height = '0px'
        this.current = -1

        if (force) {
            this.element.classList.remove(STATES.ANIMATION_DISABLED)
            this.element.offsetWidth
        }
    }

    clear(content) {
        if (content.offsetHeight > 10) {
            content.style.height = 'auto'

            if (this.delay.scroll) {
                this.scrollToView(this.current, this.delay.force, this.delay.offset)
                this.delay.offset = 0
                this.delay.scroll = false
                this.delay.force = false
            }
        }
    }

    closeAll(force = false) {
        if (this.current > -1) {
            this.close(this.current, force)
        }
    }

    scrollToView(index, force = false, offset = 0) {
        const item = this.ref.items[index]
        const box = item.getBoundingClientRect()

        if (this.current > -1 && index !== this.current) {
            const currentBox = this.ref.items[this.current].getBoundingClientRect()

            if (box.top > currentBox.top) {
                this.delay.scroll = true
                this.delay.offset = offset
                this.delay.force = force
                return
            }
        }

        if (box.top < 80 || box.top > window.innerHeight || force) {
            scrollToElement(item, offset)
        }
    }

    handleTransitionEnd = event => {
        if (event.target !== event.currentTarget) {
            return
        }

        this.clear(event.currentTarget)

        if (this.promise) {
            this.promise.resolve()
        }
    }
}